module.exports = __webpack_public_path__ + "img/eXmark.3a5da60d.png";